// import axios from 'axios'
import baseURL from '../baseUrl'

// 注册
export function register(query) {
  var url=baseURL?'/pcregister':'/api/pcregister'
  return axios({
    url,
    method: 'post',
    params: query
  })
};
// 关于我们
export function aboutus(data) {
  var url=baseURL?'/pc_aboutUs':'/api/pc_aboutUs'
  return axios({
    url,
    method: 'post',
    params: data
  })
};
// 城市列表
export function cityList(data) {
  var url=baseURL?'/pc_cityList':'/api/pc_cityList'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 登录
export function login(query, type) {
  var url=baseURL?'/publicUserLogin':'/api/publicUserLogin'
  var data = {}
  if (type == 4||type == 2) {//密码登录
    data = {
      mobile: query.mobile,
      password: query.password,
      type: 2,
      client_device: 1
    }
  } else {//验证码登录
    data = {
      mobile: query.mobile,
      code: query.password,
      type: 1,
      client_device: 1
    }
  }
  return axios({
    // url: '/userlogin',
    url,
    method: 'post',
    params: data
  })
}

// 商家登录
export function businesslogin(query, type) {
  var url=baseURL?'/businessLogin':'/api/businessLogin'
  return axios({
    // url: '/businesslogin',
    url,
    method: 'post',
    params: {
      mobile: query.mobile,
      password: query.password,
      // Vcode: query.Vcode,
      // type: type,
      client_device:1
    }
  })
}

// 发送短信请求
export function MobileCode(mobile) {
  var url=baseURL?'/getMobileVerifyCode':'/api/getMobileVerifyCode'
  return axios({
    // url: '/getMobileCode',
    url,
    method: 'post',
    params: {
      mobile: mobile
    }
  })
}

// 退出
export function logout(query, type) {
  var url=baseURL?'/userlogin':'/api/userlogin'
  return axios({
    url,
    method: 'post',
    params: {
      mobile: query.mobile,
      password: query.password,
      Vcode: query.Vcode,
      type: type
    }
  })
}

// 获取登录验证码getCode
export function getCode() {
  var url=baseURL?'/getCode':'/api/getCode'
  // eslint-disable-next-line camelcase
  var random_num = Math.random()
  // var hostname = location.hostname
  // var port = location.port
  return axios({
    url,
    method: 'post',
    params: {
      num: random_num
    }
  })
}

export function getdivCode() {
  var url=baseURL?'/getdivCode':'/api/getdivCode'
  // eslint-disable-next-line camelcase
  var random_num = Math.random()
  // var hostname = location.hostname
  // var port = location.port
  return axios({
    url,
    method: 'post',
    params: {
      num: random_num
    }
  })
}


//隐私
export function getDocument(data) {
  var url=baseURL?'/pc_document':'/api/pc_document'
  return axios({
    url,
    method: 'post',
    params: data
  })
};

//h5-邀请好友注册
export function inviteRegister(data) {
  var url=baseURL?'/inviteRegister':'/api/inviteRegister'
  return axios({
    url,
    method: 'post',
    params: data
  })
};


//忘记密码
export function forgetPassword(data) {
  var url=baseURL?'/pc_forgetPassword':'/api/pc_forgetPassword'
  return axios({
    url,
    method: 'post',
    params: data
  })
};


// WEBPACK FOOTER //
// ./src/api/member/member.js